<div class="side-container">
    <hr class="side-bar">
</div>